import React from "react";
import Grid from "@visa/vds/grid";

const MCSGridFluid = (props) => {
    let className = props.className ?? "";
    function appendClassName(append) {
        className += className.length > 0 ? " " + append : append;
    }

    switch (props.bgColor) {
        case "light-gray": appendClassName("bg-light-gray"); break;
        default: break;
    }

    switch (props.paddingTop) {
        case "small": appendClassName("padding-top-small"); break;
        case "medium": appendClassName("padding-top-medium"); break;
        case "large": appendClassName("padding-top-large"); break;
        default: break;
    }

    switch (props.paddingBottom) {
        case "small": appendClassName("padding-bottom-small"); break;
        case "medium": appendClassName("padding-bottom-medium"); break;
        case "large": appendClassName("padding-bottom-large"); break;
        default: break;
    }

    return <Grid
        className={className}
        type="fluid">
        {props.children}
    </Grid>
};

export default MCSGridFluid;
